import cloneDeep from 'lodash/cloneDeep';
import { Signal } from 'typed-signals';
import type { BlockerModel, BlockerState, TapeBlockerState, BlockerType, BlockerMatchParams } from '../../types';
import type { TileStackModel } from '../board/TileStackModel';
import MathUtils from '../../../../utils/MathUtils';
import { generateId } from '../../../../utils/generateId';

export class TapeBlockerModel implements BlockerModel {
  public readonly underTile = false;

  public readonly id = generateId('tape');

  public readonly destructible = true;

  public readonly requestRemoval = new Signal();

  public readonly onModelChanged = new Signal();

  private readonly state: TapeBlockerState;

  public readonly maxHp = 3;

  constructor(
    private readonly stack: TileStackModel,
    state: TapeBlockerState,
  ) {
    this.state = cloneDeep(state);
  }

  public onMatch({ stack, distantMatch }: BlockerMatchParams): void {
    if (!this.stack.isNeighborOf(stack) && !distantMatch) return;

    this.state.hp -= 1;
    if (this.state.hp <= 0) {
      this.requestRemoval.emit();
    } else {
      this.onModelChanged.emit();
    }
  }

  public getType(): BlockerType {
    return this.state.type;
  }

  public getHp(): number {
    return this.state.hp;
  }

  public setHp(hp: number): void {
    this.state.hp = MathUtils.clamp(hp, 0, this.maxHp);
    this.onModelChanged.emit();
  }

  public exportState(): BlockerState {
    return this.state;
  }
}
